// TO GET MERCHANDISE LIST TO MAP CLIENT
export const GET_CLIENT_MER_LIST_REQUEST = "GET_CLIENT_MER_LIST_REQUEST";
export const GET_CLIENT_MER_LIST_SUCCESS = "GET_CLIENT_MER_LIST_SUCCESS";
export const GET_CLIENT_MER_LIST_FAILURE = "GET_CLIENT_MER_LIST_FAILURE";
// SET SELECTED CLIENT IN CLIENT DASHBOARD
export const SET_SELECTED_CLIENT = "SET_SELECTED_CLIENT";
// TO POST MERCHANDISE  MAPPED WITH CLIENT DATA 
export const PUT_CLIENT_MER_LIST_REQUEST = "PUT_CLIENT_MER_LIST_REQUEST";
export const PUT_CLIENT_MER_LIST_SUCCESS = "PUT_CLIENT_MER_LIST_SUCCESS";
export const PUT_CLIENT_MER_LIST_FAILURE = "PUT_CLIENT_MER_LIST_FAILURE";